// Pure helpers for the store's GPS location — framework-free so they unit-test
// without mounting anything (same rule as src/prioritization/).

// "50.85123, 2.88456" (as copied from Google Maps), "50.85 2.88" or "50.85;2.88"
// -> {lat, lon}; null when it isn't two plausible coordinates.
export function parseCoordinates(text) {
    const m = String(text || '').trim().match(/^(-?\d{1,2}(?:\.\d+)?)\s*[,;\s]\s*(-?\d{1,3}(?:\.\d+)?)$/)
    if (!m) return null
    const lat = parseFloat(m[1])
    const lon = parseFloat(m[2])
    if (!(lat >= -90 && lat <= 90 && lon >= -180 && lon <= 180) || (lat === 0 && lon === 0)) return null
    return { lat, lon }
}

export function mapLink({ lat, lon }) {
    return `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lon}#map=17/${lat}/${lon}`
}
